import React, { useState } from 'react';
import PowerMetersTab from './powerMetersTab';
import ResidentialMetersTab from './residentialMetersTab';
import CommercialMetersTab from './commercialMetersTab';
import CommonAreaMetersTab from './commonAreaMetersTab';

const SUB_TABS = [
    { key: 'all', label: 'All Meters', component: PowerMetersTab },
    { key: 'residential', label: 'Residential Meters', component: ResidentialMetersTab },
    { key: 'commercial', label: 'Commercial Meters', component: CommercialMetersTab },
    { key: 'common_area', label: 'Common Area Meters', component: CommonAreaMetersTab },
];

const SmartPowerMetersTab = () => {
    const [activeSubTab, setActiveSubTab] = useState('all');
    const ActiveComponent = SUB_TABS.find((t) => t.key === activeSubTab)?.component;

    return (
        <div>
            <ul className="nav nav-tabs">
                {SUB_TABS.map((tab) => (
                    <li className="nav-item" key={tab.key}>
                        <button
                            className={`nav-link ${activeSubTab === tab.key ? 'active' : ''}`}
                            onClick={() => setActiveSubTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>
            <div className="tab-content mt-3">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default SmartPowerMetersTab;
